import clsx from 'clsx'
import { RiDeleteBinFill } from '@remixicon/react'
import { RemoveMediaButton } from '../removeMediaButton'
import { VideoPreview } from './postModalPreviewVideo.styles'
import { PostModalPreviewVideoProps } from './postModalPreviewVideo.types'

const PostModalPreviewVideo = ({
  linkVideo,
  classNameVideo,
  classNameContainer,
  onRemoveMedia
}: PostModalPreviewVideoProps) => {
  return (
    <div
      className={clsx('_position-relative', classNameContainer)}
      data-test="post-modal-preview-video"
    >
      <RemoveMediaButton
        className="_align-items-center _justify-content-center _text-gray-500"
        onRemove={onRemoveMedia}
        icon={<RiDeleteBinFill size={24} />}
        showBackground
      />

      <VideoPreview data-test="video-preview" className={classNameVideo} src={linkVideo} controls />
    </div>
  )
}

export default PostModalPreviewVideo
